// src/components/pages/StudentCourses.jsx
import React, { useCallback, useEffect, useState } from "react";
import { Button, Skeleton } from "antd";
import API from "API";
import BaseList from "components/general/Management/BaseList";
import { useNavigate } from "react-router-dom";
import TermHandle from "components/pages/UniversitySide/UniversityTerms/TermHandle";
import dayjs from "dayjs";
import { useAuth } from "AuthContext";

const NOW = dayjs();

const StudentCourses = () => {
    const navigate = useNavigate();
    const [terms, setTerms] = useState(null);
    const [selectedTerm, setSelecterdTerm] = useState(null);
    const [gettingTerm, setGettingTerm] = useState(true);
    const [reloadKey, setReloadKey] = useState(true);
    const { user } = useAuth();

    useEffect(() => {
        setReloadKey((prev) => !prev);
    },[selectedTerm])

    const fetchData = useCallback(async ({ searchTerm, page, pageSize }) => {
        if (user.role === 100 && !selectedTerm) return {
            data: [],
            total: 0
        };
        const response = await API.get("/student/courses/", {
            params: {
                search: searchTerm,
                page: page || 1,
                page_size: pageSize || 10,
                term: selectedTerm?.id,
            },
        })

        const tranformData = (value) => ({
          ...value,
          formatName: `${value.code} - ${value.name}`,
          formatDescription: `<b>Tín chỉ:</b> ${value.credit}<br/>${value.description}`
        })
        
        return {
            data: response.data.results.map(tranformData),
            total: response.data.count,
        };
    }, [selectedTerm, user])

    useEffect(() => {
        async function getTermData() {
            try {
                setGettingTerm(true);
                const response = await API.get("/student/terms/", {
                    params: {
                        page_size: 1000
                    }
                });
                var check = false;
                for (const r of response.data.results) {
                    r.start_time = dayjs(r.start_time);
                    r.end_time = dayjs(r.end_time);
                    if (r.register_start_time) r.register_start_time = dayjs(r.register_start_time);
                    if (r.register_end_time) r.register_end_time = dayjs(r.register_end_time);
                    if (!check) {
                        if (r.start_time.isBefore(NOW) && r.end_time.isAfter(NOW)) {
                            check = true;
                            setSelecterdTerm(r);
                        }
                    }
                }
                if (!check) {
                    setSelecterdTerm(response.data.results[0] || null);
                }
                setTerms(response.data.results);
                setGettingTerm(false);
            } catch (e) {
                console.log(e);
            } finally {

            }
        }
        if (user.role === 100) {
            getTermData();
        }
    }, [user])

    return <div>
        <h2>Môn Học Của Tôi</h2>
        {user.role === 100 && (gettingTerm ? <Skeleton active /> : <TermHandle terms={terms} setTerms={setTerms} edit={false}
            selectedTerm={selectedTerm} setSelecterdTerm={setSelecterdTerm} />)}
        <BaseList
            fetchData={fetchData}
            itemName="môn học"
            listMode="card"
            reloadKey={reloadKey}
            defaultLogo={process.env.PUBLIC_URL + '/img/standard-logo.png'}
            customActions={(item) => (
                <Button
                    type="primary"
                    onClick={(e) => {
                        navigate(`/student-courses/${item.id}`)
                    }}
                >
                    Vào môn học
                </Button>
            )}
        />
    </div>
};

export default StudentCourses;
